import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { OtherActivity as PrivateActivity } from '@src/types/shared/other_activity';
import { nanoid } from 'nanoid';
import type { RootState } from '..';

type State = { privateActivities: PrivateActivity[] };

const initialState: State = { privateActivities: [] };

const privateActivitySlice = createSlice({
  name: 'privateActivity',
  initialState,
  reducers: {
    addPrivateActivity(state, action: PayloadAction<Omit<PrivateActivity, 'id'>>) {
      state.privateActivities.push({ ...action.payload, id: nanoid() });
    },
    updatePrivateActivity(state, action: PayloadAction<{ index: number; item: PrivateActivity }>) {
      const { index, item } = action.payload;
      if (index >= 0 && index < state.privateActivities.length) {
        state.privateActivities[index] = item;
      }
    },
    updatePrivateActivityFromStorage(state, action: PayloadAction<PrivateActivity[]>) {
      state.privateActivities = action.payload;
    },
    removePrivateActivity(state, action: PayloadAction<number>) {
      state.privateActivities.splice(action.payload, 1);
    },
    reorderPrivateActivities(state, action: PayloadAction<PrivateActivity[]>) {
      state.privateActivities = action.payload;
    },
  },
});

export const {
  addPrivateActivity,
  updatePrivateActivity,
  updatePrivateActivityFromStorage,
  removePrivateActivity,
  reorderPrivateActivities,
} = privateActivitySlice.actions;

export const selectPrivateActivity = (state: RootState): PrivateActivity[] =>
  state.privateActivity.privateActivities;

export default privateActivitySlice.reducer;
